import axios from 'axios';

export interface Notification {
  id: number;
  img: string;
  title: string;
  description: string;
  recipients: string[] | null;
  status: 'activo' | 'inactivo';
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9999/api/v1/back';
const AUTH_TOKEN = 'FeMsA@2024';

export const getNotifications = async (): Promise<Notification[]> => {
  try {
    const response = await axios.get(`${API_URL}/notifications`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AUTH_TOKEN}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

export const deleteNotification = async (id: number): Promise<boolean> => {
  try {
    await axios.delete(`${API_URL}/notifications/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AUTH_TOKEN}`
      }
    });
    return true;
  } catch (error) {
    console.error('Error deleting notification:', error);
    throw error;
  }
};

export interface CreateNotificationData {
  title: string;
  description: string;
  img: string;
  recipients?: string;
}

export interface UpdateNotificationData {
  id: number;
  title: string;
  description: string;
  img: string;
  recipients?: string;
  status: 'activo' | 'inactivo';
}

export const updateNotification = async (data: UpdateNotificationData): Promise<Notification> => {
  try {
    const response = await axios.put(
      `${API_URL}/notifications`,
      {
        id: data.id,
        title: data.title,
        description: data.description,
        img: data.img,
        recipients: data.recipients || "",
        status: data.status
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating notification:', error);
    throw error;
  }
};

export const createNotification = async (data: CreateNotificationData): Promise<Notification> => {
  try {
    const response = await axios.post(
      `${API_URL}/notifications`,
      {
        title: data.title,
        description: data.description,
        img: data.img,
        recipients: data.recipients || ""
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating notification:', error);
    throw error;
  }
};

export const updateNotificationStatus = async (id: number, status: 'activo' | 'inactivo'): Promise<Notification> => {
  try {
    const response = await axios.put(
      `${API_URL}/notifications/change_status`,
      { id, status },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating notification status:', error);
    throw error;
  }
};
